import React from 'react'
import { toast } from 'react-toastify';

function Setting() {

    const [formData, setFormData] = React.useState({
        CommissionPercentage: 30,
    })

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        toast.success("Settings updated successfully.");
        console.log(formData);
        }

  return (
    
      <div className="deposit">
        <h1 className="main-heading">Settings</h1>


        <div className="adpa-first">
          <div className="adpafi-top">
            <h2>Master settings</h2>
          </div>
          <div className="adpafi-body">
            <form onSubmit={handleFormSubmit}>
             

              <div className="input-group">
                <label>Commission Percentage</label>
                <input
                  type="text"
                  name="CommissionPercentage"
                  value={formData.CommissionPercentage + "%"}
                  onChange={handleInputChange}
                  required
                />
              </div>

             
              <div className="button-group">
                <button type="submit">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
  )
}

export default Setting